import {Box} from '@miro-site/core'
import React from 'react'

import type {IconProps} from './Icons'

const Close: React.FC<IconProps> = ({width = 16, height = 16}) => (
  <Box
    as="svg"
    $styles={{width, height}}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 6L8 10L12 6" stroke="#050038" strokeWidth="2" strokeLinecap="round" />
  </Box>
)

export default Close
